import { createFeatureHook } from '@edreamsodigeo/frontend-core';
import { EQUAL_PROMINENCE_MOBILE } from 'clientState/ab/aliases';
import { useEqualProminencePrimeDisplayMobile } from 'clientState/hooks/useEqualProminencePrimeDisplayMobile';

export const useEqualProminencePrimeDisplayMobileInResults = createFeatureHook({
  name: EQUAL_PROMINENCE_MOBILE,
  variations: [null, null, null, useEqualProminencePrimeDisplayMobile],
  version: 1,
});
